import { ThreeDots } from 'assets/icons/ThreeDots'
import { Badge } from 'components/Badge/Badge'
import { Container, ContainerContent, ContainerHeader, ContainerOptions } from 'components/Containers/Containers'
import { NavBar } from 'components/NavBar/NavBar'
import { useState } from 'react'
import { Button, ColoredDot, Dropdown, Flex, H1WithBack, PageWrapper } from 'styling/GlobalStyles'
import { BodyText, OtherText, TitleText } from 'styling/Typography'
import { IPhaseModal } from 'types/phases.interface'
import { PhasesModal } from './PhasesModal'

export const Phases = () => {
    const [modal, setModal] = useState<{ open: boolean, value: IPhaseModal | null }>({ open: false, value: null })


    const Phase = () => {
        const [open, setOpen] = useState(false)
        const [options, setOptions] = useState(false)
        return <Container style={{ overflow: 'visible' }} >
            <ContainerHeader style={{ cursor: 'pointer' }} onClick={() => setOpen(!open)} >
                <Flex width='100%' between >
                    <TitleText weight='bold'>Phase 1 - Mill audit</TitleText>
                    <Flex center gap='1rem' >
                        <Badge hexColor='#ff9900'>
                            <Flex gap='1rem' center >
                                <ColoredDot color='#ff9900' />
                                <BodyText>ACTIVE</BodyText>
                            </Flex>
                        </Badge>
                        {/* <Chevron /> */}
                        <ContainerOptions
                            tabIndex={0}
                            onBlur={() => setOptions(false)}
                            onClick={(e) => {
                                e.stopPropagation()
                                setOptions(true)
                            }}
                        >
                            <span>
                                <ThreeDots />
                            </span>
                            <Dropdown left show={options}>
                                <Flex>
                                    <TitleText>Edit</TitleText>
                                </Flex>
                                <Flex>
                                    <TitleText>Details</TitleText>
                                </Flex>
                                <Flex>
                                    <TitleText>Complete</TitleText>
                                </Flex>
                                <Flex>
                                    <TitleText>Skip</TitleText>
                                </Flex>
                            </Dropdown>
                        </ContainerOptions>
                    </Flex>
                </Flex>
            </ContainerHeader>
            {open && <ContainerContent>
                <Flex column gap='1.5rem'>
                    <Flex gap='1rem'>
                        <OtherText grey >PROCESS TEMPLATE</OtherText>
                        <OtherText>1</OtherText>
                    </Flex>
                    <Flex gap='1rem'>
                        <OtherText grey >PROCESS TEMPLATE</OtherText>
                        <OtherText>1</OtherText>
                    </Flex>
                    <Flex gap='1rem'>
                        <OtherText grey >PROCESS TEMPLATE</OtherText>
                        <OtherText>1</OtherText>
                    </Flex>
                </Flex>
            </ContainerContent>}
        </Container>
    }

    return <>
        <NavBar />
        <PageWrapper>
            <Flex center between >
                <H1WithBack title='Phases' arrow />
                <Button orange onClick={() => setModal({ open: true, value: null })} >Add</Button>
            </Flex>
            <Flex column gap='1rem' mt='32'>
                <Phase />
            </Flex>
        </PageWrapper>
        {modal.open && <PhasesModal value={modal.value} closeModal={() => setModal({ open: false, value: null })} />}
    </>
}